import React from 'react'
import api, { AppUser, ChangePasswordInput } from 'api'
import { Button, Form, Input, message } from 'antd'
import { AppEvent } from 'components/AppEvent'

interface IState {
	model: AppUser
	changePasswordInput?: ChangePasswordInput
	modifyPsw: boolean
}

export default class extends React.PureComponent<{ model?: AppUser }> {
	state: IState = { model: {}, changePasswordInput: {}, modifyPsw: false }

	async componentDidMount() {
		let model = await api.appuser.getCurrUser()
		let changePasswordInput = { userId: model.id, password: '' }
		this.setState({ model, changePasswordInput })
	}

	onValueChange = (e: any) => {
		let { changePasswordInput } = this.state
		changePasswordInput.password = e.target.value
		this.setState({ changePasswordInput })
	}

	handleSubmit = async () => {
		let { changePasswordInput } = this.state
		await api.appuser.changePassword(changePasswordInput)
		message.success('保存成功')
		this.setState({ modifyPsw: false })
		AppEvent.closeDialog()
	}

	render() {
		return (
			<div style={{ height: '100px' }}>
				<Form layout="vertical">
					<Input type="password" onChange={this.onValueChange} placeholder="请输入新密码" />
				</Form>
				<br />
				<div style={{ textAlign: 'center' }}>
					<Button type="primary" onClick={this.handleSubmit} htmlType="submit">
						保存密码
					</Button>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/Home/PasswordForm.tsx